import fetch from '../utils/fetch';

const BaseUrl = process.env.API_BASE || process.env.MONO_BASE;

const getUrl = (path) => `${BaseUrl}${path}`;

export default {
  /**
   * Get polls with their displays
   * @param {Object} query - Query parameters (limit, search, tags)
   * @returns {Object} Response with { polls: [] }
   */
  async getPolls(query = {}) {
    return fetch(getUrl('/polls'), { query });
  },

  /**
   * Get a single poll with its display data
   * @param {string} pollId - The poll ID
   * @returns {Object} Poll data with display information including rounds and displays
   */
  async getPollById(pollId) {
    return fetch(getUrl(`/polls/${pollId}`));
  },
};
